

import axios from "axios";
import { useEffect, useId, useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import '../../styles/videodata.css'
import SidebarAdminMain from "../SidebarAdminMain";
import { CSVLink } from "react-csv";
import swal from "sweetalert";
import { BASE_URL, tableCustomStyles } from "../../App";







function StudentWeek() {
    

    const navigate = useNavigate();
  
  
  const [week , setWeek] = useState([]);
  
    const {id} = useParams()


    const token = localStorage.getItem('token' );
    const axiosInstance = axios.create({
    baseURL: `${BASE_URL}`,
  
});



const getStudentWeek = async () => {
    try {
      const token = localStorage.getItem('token' );
      const response = await axiosInstance.get(`/api/weekStudents/${id}` , {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            "ngrok-skip-browser-warning": "any",
          },
        });
        // console.log(response.data.data.map(item => item.id))
        // console.log(response.data.data);
        setWeek(response.data.data)
        // setFilteredData(response.data.data);
        const data = response.data.data;
                 return data;
    } catch (error) {
        // console.log(error);
    }
}
useEffect (() =>{
    getStudentWeek();
}, [])





const totalStudent = week.length


const [rows, setRows] = useState([]);



const deleteRow = async(id, token) => {
    try {
        const response = await axios.delete(`${BASE_URL}/api/deleteWeekUser/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        swal({
          title: "تم حذف هذا الطالب  بنجاح!",
          icon: "success",
          button: "حسناّ!",
        });
    } catch (error) {
        // console.error(error);
        
    }
  };

  
  const handleDeleteClick = async (id) => {
    const token = localStorage.getItem('token');
    try {
        await deleteRow(id, token);
        const updateStudentWeek = week.filter(row => row.id !== id);
        setWeek(updateStudentWeek);
    } catch (error) {
        // console.error(error);
    }
  };
  


const [filteredData, setFilteredData] = useState([]);
const [searchTerm, setSearchTerm] = useState("");

  const [showEnrollModal, setShowEnrollModal] = useState(false);
  const [enrollBy, setEnrollBy] = useState("user_id");
  const [enrollUserId, setEnrollUserId] = useState("");
  const [enrollPhone, setEnrollPhone] = useState("");
  const [enrollLoading, setEnrollLoading] = useState(false);

  const handleEnrollStudent = async (e) => {
    e.preventDefault();
    const uid = enrollUserId.trim();
    const phoneVal = enrollPhone.trim();

    if (enrollBy === "user_id") {
      if (!uid) {
        swal({ title: "أدخل معرف الطالب", icon: "warning", button: "حسناً" });
        return;
      }
    } else if (!phoneVal) {
      swal({ title: "أدخل رقم الموبايل", icon: "warning", button: "حسناً" });
      return;
    }

    const body = { week_id: Number(id) };
    if (enrollBy === "user_id") {
      body.user_id = Number(uid);
    } else {
      body.phone = phoneVal;
    }

    setEnrollLoading(true);
    try {
      await axios.post(`${BASE_URL}/api/weeks/enroll-student`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "any",
        },
      });
      swal({
        title: "تم تسجيل الطالب في الأسبوع بنجاح!",
        icon: "success",
        button: "حسناً!",
      });
      setShowEnrollModal(false);
      setEnrollUserId("");
      setEnrollPhone("");
      setFilteredData([]);
      await getStudentWeek();
    } catch (error) {
      const data = error.response?.data;
      const msg =
        (typeof data?.message === "string" && data.message) ||
        data?.error ||
        (Array.isArray(data?.errors) && data.errors[0]) ||
        "تعذر إضافة الطالب";
      swal({ title: String(msg), icon: "error", button: "حسناً" });
    } finally {
      setEnrollLoading(false);
    }
  };

const handleSearch = (e) => {
  setSearchTerm(e.target.value);
  const searchResults = week.filter((item) => {
    return (
      item.attributes.name.toLowerCase().includes(e.target.value.toLowerCase()) 
    );
  });
  setFilteredData(searchResults);
};


    const columns = [
 
   
      
      {
        name: "UserId ",
        selector: (row) => row.attributes.user_id,
        sortable : true,
      //   style: {
      //     background: "#e6e6e6",
      //   }
      grow:2,
      },
      {
        name: "Name ",
        selector: (row) => row.attributes.name,
        sortable : true,
      //   style: {
      //     background: "#e6e6e6",
      //   }
      grow:2,
      },
      {
        name: "Phone ",
        selector: (row) => row.attributes.phone,
        sortable : true,
      //   style: {
      //     background: "#e6e6e6",
      //   }
      grow:2,
      },
      {
        name: "Enroll Time",
        selector: (row) => row.attributes.created_at,
        sortable : true,
      //   style: {
      //     background: "#e6e6e6",
      //   }
      grow:2,
      },
      {
        name: "Phone ",
        selector: (row) => row.attributes.phone,
        sortable : true,
      //   style: {
      //     background: "#e6e6e6",
      //   }
      grow:2,
      },
      // {
      //   name: "Country Flag",
      //   selector: (row) => <img width={10} height={10} src={row.flag} alt="" />,
      // },
      {
        name: "Delete",
        cell: row =>  <button style={{background:"#" , border: "none"}} className="btn btn-danger pe-lg-2 ps-lg-2 pe-2 ps-2 pt-2 pb-2" onClick={() => alert(' هل انت متأكد من  مسح هذا الطالب من الحصة ') | handleDeleteClick(row.id)}>Delete</button> ,
        
      },

     
    ];
    
    return (
        <>
      <div className="d-flex">
    
       <div className="video-data">
      
      <div className="main-title">  طلاب هذا الأسبوع </div>
    
      <Container>
    
          <Row>
         
          <Col lg={12}>
                     <div className="quiz-content">
              <DataTable
                                           customStyles={tableCustomStyles}

               columns={columns}
               data={filteredData.length > 0 ? filteredData : week} 
                pagination 
                fixedHeader
                // selectableRows
                // fixedHeaderScrollHeight="400px"
                highlightOnHover
                actions={
                  <>
                    <Button
                      variant="primary"
                      className="mb-3 mt-4 me-2"
                      onClick={() => setShowEnrollModal(true)}
                    >
                      إضافة طلاب
                    </Button>
                    <CSVLink
                      data={filteredData.length > 0 ? filteredData : week}
                      filename="الطلاب الممتحنين"
                      className="btn btn-success mb-3 mt-4 me-2"
                    >
                      Export File Excel
                    </CSVLink>
                  </>
               }
           
                subHeader
                subHeaderComponent={
                  <>
                      <div className="total-search">
                  <h3 className="total-student mb-4"> <span>{totalStudent}</span> : اجمالي عدد الطلاب  اللي شافو الحصة  </h3>
                      <input type="text" className="form-control mt-4 mb-4 w-100" placeholder="Search of Student" onChange={handleSearch} /> 
                      </div>
                  </>
                
                }
                
                />
              </div>
                                          </Col>
          </Row>
      </Container>

      <Modal
        show={showEnrollModal}
        onHide={() => !enrollLoading && setShowEnrollModal(false)}
        centered
        size="lg"
        dialogClassName="enroll-week-modal"
        dir="rtl"
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-end pe-1">إضافة طالب للأسبوع</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleEnrollStudent}>
          <Modal.Body>
            <Form.Group className="mb-4">
              <div className="enroll-method-label">طريقة الإضافة</div>
              <div className="enroll-method-options" role="radiogroup" aria-label="طريقة الإضافة">
                <label className="enroll-option-tile" htmlFor="enroll-by-user-id">
                  <input
                    className="form-check-input enroll-radio-input"
                    type="radio"
                    id="enroll-by-user-id"
                    name="enrollBy"
                    checked={enrollBy === "user_id"}
                    onChange={() => setEnrollBy("user_id")}
                  />
                  <span className="enroll-option-text">معرف المستخدم (user_id)</span>
                </label>
                <label className="enroll-option-tile" htmlFor="enroll-by-phone">
                  <input
                    className="form-check-input enroll-radio-input"
                    type="radio"
                    id="enroll-by-phone"
                    name="enrollBy"
                    checked={enrollBy === "phone"}
                    onChange={() => setEnrollBy("phone")}
                  />
                  <span className="enroll-option-text">رقم الموبايل</span>
                </label>
              </div>
            </Form.Group>
            {enrollBy === "user_id" ? (
              <Form.Group className="mb-1">
                <Form.Label className="enroll-field-label">معرف الطالب</Form.Label>
                <Form.Control
                  className="enroll-field-input"
                  type="number"
                  min={1}
                  placeholder=""
                  value={enrollUserId}
                  onChange={(e) => setEnrollUserId(e.target.value)}
                  disabled={enrollLoading}
                  size="lg"
                />
              </Form.Group>
            ) : (
              <Form.Group className="mb-1">
                <Form.Label className="enroll-field-label">رقم الموبايل</Form.Label>
                <Form.Control
                  className="enroll-field-input"
                  type="text"
                  inputMode="tel"
                  autoComplete="tel"
                  placeholder=" "
                  value={enrollPhone}
                  onChange={(e) => setEnrollPhone(e.target.value)}
                  disabled={enrollLoading}
                  size="lg"
                />
              </Form.Group>
            )}
          </Modal.Body>
          <Modal.Footer className="d-flex flex-row-reverse flex-wrap justify-content-start gap-2">
            <Button variant="primary" type="submit" disabled={enrollLoading} className="order-1">
              {enrollLoading ? "جاري الإضافة..." : "تسجيل"}
            </Button>
            <Button variant="secondary" type="button" disabled={enrollLoading} onClick={() => setShowEnrollModal(false)}>
              إلغاء
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

    
      </div>
      <div className="sidebar">
       <SidebarAdminMain />
       </div>
       </div>
        </>
    )
}

export default StudentWeek;

